/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-toggle-button.get-names.ts 
*/
:host {
  font-feature-settings: "liga" on;
  -moz-font-feature-settings: "liga" on;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  box-sizing: border-box;
  display: inline-block;
}
:host * {
  box-sizing: border-box;
}

:host([full-width]) {
  width: 100%;
}

:host([full-width-mobile]) {
  width: 100%;
}
@media only screen and (min-width: 595px) {
  :host([full-width-mobile]) {
    width: unset;
  }
}

:host([full-width-tablet]) {
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  :host([full-width-tablet]) {
    width: unset;
  }
}

.ace-toggle-button {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font-feature-settings: "liga" on;
  -moz-font-feature-settings: "liga" on;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-size: var(--ace-type-font-size-text-small);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-type-line-height-text-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  align-items: center;
  border-radius: var(--ace-semantic-buttons-toggle-button-radius);
  cursor: pointer;
  display: flex;
  justify-content: center;
  text-overflow: ellipsis;
  transition: background-color linear 100ms, border linear 100ms;
  white-space: nowrap;
  width: fit-content;
  backdrop-filter: blur(1.25rem);
  -webkit-backdrop-filter: blur(1.25rem);
}
.ace-toggle-button svg,
.ace-toggle-button span > svg {
  fill: var(--ace-color-text-neutral--interactive);
}
.ace-toggle-button--full-width {
  width: 100%;
}
.ace-toggle-button--full-width-mobile {
  width: 100%;
}
@media only screen and (min-width: 595px) {
  .ace-toggle-button--full-width-mobile {
    width: unset;
  }
}
.ace-toggle-button--full-width-tablet {
  width: 100%;
}
@media only screen and (min-width: 1025px) {
  .ace-toggle-button--full-width-tablet {
    width: unset;
  }
}
.ace-toggle-button:focus-visible {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
}
.ace-toggle-button[aria-disabled=true] {
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  color: var(--ace-color-text-neutral--disabled);
  cursor: auto;
}
.ace-toggle-button[aria-disabled=true] svg,
.ace-toggle-button[aria-disabled=true] span > svg {
  color: var(--ace-color-text-neutral--disabled);
}
.ace-toggle-button--size-regular {
  font-size: var(--ace-type-font-size-text-small);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-type-line-height-text-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  gap: var(--ace-primitive-spacing-xx-tight);
  height: var(--ace-toggle-button-height, 2.5rem);
  min-width: 2.5rem;
  padding: 0 var(--ace-primitive-spacing-normal);
}
.ace-toggle-button--size-small {
  font-size: var(--ace-type-font-size-text-x-small);
  letter-spacing: var(--ace-type-letter-spacing-text-x-small);
  line-height: var(--ace-type-line-height-text-x-small);
  font-family: var(--ace-type-font-family-interactive);
  font-weight: var(--ace-type-font-weight-interactive);
  text-decoration: none;
  gap: var(--ace-semantic-buttons-toggle-button-prefix-label-padding);
  height: var(--ace-toggle-button-height, var(--ace-semantic-buttons-toggle-button-dimension-button));
  min-width: var(--ace-semantic-buttons-toggle-button-dimension-button);
  padding: 0 var(--ace-semantic-buttons-toggle-button-side-padding);
  border-radius: var(--ace-toggle-button-border-radius, var(--ace-semantic-buttons-toggle-button-radius));
}
.ace-toggle-button--default {
  background: var(--ace-color-brand-tertiary--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--200);
  border-radius: var(--ace-toggle-button-border-radius, var(--ace-primitive-radius-full));
  color: var(--ace-color-text-neutral--interactive);
  position: relative;
}
.ace-toggle-button--default:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-tertiary--200);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--300);
  text-decoration: none;
}
.ace-toggle-button--default[aria-disabled=true] {
  background-color: var(--ace-color-surface-solid--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--100);
  color: var(--ace-color-text-neutral--disabled);
}
.ace-toggle-button--default--active, .ace-toggle-button--default--active:disabled {
  background-color: var(--ace-semantic-buttons-toggle-button-active-background-color);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-toggle-button-active-background-color);
  color: var(--ace-color-text-neutral--interactive-uni-light);
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
}
.ace-toggle-button--default--active:hover:not([aria-disabled=true]) {
  background-color: var(--ace-semantic-buttons-toggle-button-active-background-color-hover);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-toggle-button-active-background-color-hover);
  color: var(--ace-color-text-neutral--interactive-uni-light);
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
}
.ace-toggle-button--hidden {
  background-color: transparent;
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  border-radius: var(--ace-toggle-button-border-radius, var(--ace-primitive-radius-full));
  color: var(--ace-color-text-neutral--interactive);
}
.ace-toggle-button--hidden:hover:not([aria-disabled=true]) {
  background-color: var(--ace-color-brand-tertiary--200);
  border: var(--ace-semantic-foundation-border-interactive) transparent;
  text-decoration: none;
}
.ace-toggle-button--hidden[aria-disabled=true] {
  background-color: var(--ace-color-surface-solid--100);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-color-borders--100);
  color: var(--ace-color-text-neutral--disabled);
}
.ace-toggle-button--hidden--active, .ace-toggle-button--hidden--active:disabled {
  background-color: var(--ace-semantic-buttons-toggle-button-active-background-color);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-toggle-button-active-background-color);
  color: var(--ace-color-text-neutral--interactive-uni-light);
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
}
.ace-toggle-button--hidden--active:hover:not([aria-disabled=true]) {
  background-color: var(--ace-semantic-buttons-toggle-button-active-background-color-hover);
  border: var(--ace-semantic-foundation-border-interactive) var(--ace-semantic-buttons-toggle-button-active-background-color-hover);
  color: var(--ace-color-text-neutral--interactive-uni-light);
  backdrop-filter: unset;
  -webkit-backdrop-filter: unset;
}
.ace-toggle-button--circular {
  border-radius: var(--ace-primitive-radius-full);
  padding: unset;
}